'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _input = require('../components/input');
var _input2 = _interopRequireDefault(_input);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
Email.propTypes = {
  name: _propTypes.string,
  label: _propTypes.string,
  placeholder: _propTypes.string,
  helpText: _propTypes.string
};
Email.defaultProps = {
  name: 'email',
  label: 'Email',
  placeholder: "We won't send you SPAM e-mails",
  helpText: undefined
};
function Email(props) {
  var label = props.label,
    name = props.name,
    placeholder = props.placeholder,
    helpText = props.helpText,
    inputProps = _objectWithoutProperties(props, ['label', 'name', 'placeholder', 'helpText']);
  return _react2.default.createElement(_input2.default, Object.assign({
    label: label,
    name: name,
    placeholder: placeholder,
    helpText: helpText,
    type: 'email'
  }, inputProps));
}
exports.default = Email;